
  var _styles = {
  "multistate-redpacket": {
    "display": "flex",
    "justifyContent": "center",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "auto-image-loading": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "width": "100%",
    "height": "100%",
    "backgroundColor": "rgba(255,255,255,0.8)"
  }
};



  module.exports = _styles;
  